export default [
  { key: 'CONNECTWISE', icon: { src: '/images/connectwise-logo.png', width: 123 } },
  { key: 'AUTOTASK', icon: { src: '/images/autotask-logo.png', width: 96 } },
  { key: 'HALO', icon: { src: '/images/halo-logo.png', width: 90 } }
];
